import { Col, Divider, InputNumber, InputNumberProps, Row, Slider, Typography } from 'antd';
import { SenseMode } from '../../../types/types';

type TimingParametersProps = {
  baselineDuration: number; // default: 5 (handled in parent)
  setBaselineDuration: React.Dispatch<React.SetStateAction<number>>;

  analyteDuration: number; // default: 20 (handled in parent)
  setAnalyteDuration: React.Dispatch<React.SetStateAction<number>>;

  desorptionDuration: number; // default: 20 (handled in parent)
  setDesorptionDuration: React.Dispatch<React.SetStateAction<number>>;
};

const TimingParameters: React.FC<TimingParametersProps> = ({ baselineDuration, setBaselineDuration, analyteDuration, setAnalyteDuration, desorptionDuration, setDesorptionDuration }) => {
  // helpers to handle null values before updating parameters
  const onBaselineDurationChange: InputNumberProps['onChange'] = (newValue) => {
    if (newValue === null) return;
    let x = newValue as number;
    setBaselineDuration(x);
  };

  const onAnalyteDurationChange: InputNumberProps['onChange'] = (newValue) => {
    if (newValue === null) return;
    let x = newValue as number;
    setAnalyteDuration(x);
  };

  const onDesorptionDurationChange: InputNumberProps['onChange'] = (newValue) => {
    if (newValue === null) return;
    let x = newValue as number;
    setDesorptionDuration(x);
  };

  return (
    <>
      <Typography.Title level={5}>Timing Parameters (seconds)</Typography.Title>
      {/* Baseline */}
      <Row gutter={[16, 8]} style={{ marginBottom: 16 }}>
        <Col span={24}>
          <Typography.Text>Baseline duration</Typography.Text>
        </Col>
        <Col span={16}>
          <Slider min={1} max={10} value={baselineDuration} onChange={onBaselineDurationChange} />
        </Col>
        <Col span={8}>
          <InputNumber min={1} max={10} style={{ width: '100%' }} value={baselineDuration} onChange={onBaselineDurationChange} />
        </Col>
      </Row>
      {/* Analyte */}
      <Row gutter={[16, 8]} style={{ marginBottom: 16 }}>
        <Col span={24}>
          <Typography.Text>Analyte duration</Typography.Text>
        </Col>
        <Col span={16}>
          <Slider min={1} max={10000} value={analyteDuration} onChange={onAnalyteDurationChange} />
        </Col>
        <Col span={8}>
          <InputNumber min={1} max={10000} style={{ width: '100%' }} value={analyteDuration} onChange={onAnalyteDurationChange} />
        </Col>
      </Row>
      {/* Desorption */}
      <Row gutter={[16, 8]}>
        <Col span={24}>
          <Typography.Text>Desorption duration</Typography.Text>
        </Col>
        <Col span={16}>
          <Slider min={1} max={180} value={desorptionDuration} onChange={onDesorptionDurationChange} />
        </Col>
        <Col span={8}>
          <InputNumber min={1} max={180} style={{ width: '100%' }} value={desorptionDuration} onChange={onDesorptionDurationChange} />
        </Col>
      </Row>
      <Divider />
    </>
  );
};

export default TimingParameters;
